import React from "react";
import Skeleton from "react-loading-skeleton";
import styles from "../EventDetail.module.css";

const EventPopupSkeleton = () => {
  return (
    <div className={styles.DetailPopup}>


        <h2 className={styles.Title}>
          <Skeleton count={1} style={{ width: "75%" }} />
        </h2>
        <div>
          <Skeleton height={468} style={{ marginBottom: 30 }} />
        </div>

        <div className={styles.DateRow}>
          <div className={styles.DateItem}>
            <Skeleton count={1} width={100} />
          </div>
          <div className={styles.DateItem}>
            <Skeleton count={1} width={100} />
          </div>
        </div>
        <div className={styles.Content}>
          <Skeleton count={6} />
        </div>
        <div className="text-center" style={{marginTop: 20}}>
        <Skeleton width={260} height={36} />
        </div>
      </div>

  );
};

export default EventPopupSkeleton;
